import { memo } from "react";

import { areEqual } from "react-window";

import { type MyLensesLens } from "../../../../gql-generated/types";
import { LoadableItem } from "../../../../shared/components";
import { type VirtualizedListItemProps } from "../../../../shared/models";
import { type LensModalProps } from "../../../models";

import { LensRow } from "./LensRow";

export interface LoadableLensRowData {
    submissionErrorsProps: LensModalProps;
    distributionRestrictionsProps: LensModalProps;
}

export const LoadableLensRow = memo<VirtualizedListItemProps<MyLensesLens, LoadableLensRowData>>(
    ({ index, style, data: { list, data } }) => {
        const lens = list[index];

        return (
            <LoadableItem style={style} data={lens} skeletonHeight={16}>
                {lens && data ? (
                    <LensRow
                        style={style}
                        lens={lens}
                        rowIndex={index}
                        submissionErrorsProps={data.submissionErrorsProps}
                        distributionRestrictionsProps={data.distributionRestrictionsProps}
                    />
                ) : (
                    <></>
                )}
            </LoadableItem>
        );
    },
    areEqual,
);
